<template>
  <div>
    <v-dialog v-model="show" persistent max-width="40%">
      <!-- 6 Digit code -->
      <v-card :class="showPassword ? 'd-none' : ''">
        <v-app-bar text color="secondary">
          <v-toolbar-title class="subheading">{{ $t("auth.verification") }}</v-toolbar-title>
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="pa-2 mt-4">
          <v-form data-vv-scope="codeform">
            <v-container class="px-4">
              <v-layout row wrap>
                <v-flex md12>
                  <p>{{ $t("auth.code_instruction") }}</p>
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    name="auth.code"
                    v-model="code"
                    v-validate="'required|digits:6'"
                    :label="$t('auth.code_enter')"
                    :error-messages="errors.collect('auth.code')"
                    data-vv-scope="codeform"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <action-button type="default" :text="$t('global.cancel')" @click="cancel" />
          <action-button type="default" :text="$t('auth.verify')" @click="verify" />
        </v-card-actions>
      </v-card>

      <!-- Password -->
      <v-card :class="showPassword ? '' : 'd-none'">
        <v-app-bar text color="secondary">
          <v-toolbar-title class="subheading">{{ $t("auth.set_password") }}</v-toolbar-title>
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-form data-vv-scope="passwordform">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="new_password"
                  class="required-field"
                  v-validate="'required|password_strength'"
                  :label="$t('auth.new_password')"
                  :error-messages="errors.collect('auth.new_password')"
                  data-vv-name="auth.new_password"
                  type="password"
                  prepend-icon="lock"
                  ref="new_password"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="new_password_retype"
                  class="required-field"
                  v-validate="'required|confirmed:new_password|password_strength'"
                  :label="$t('auth.new_password_retype')"
                  :error-messages="errors.collect('auth.new_password_retype')"
                  data-vv-name="auth.new_password_retype"
                  type="password"
                  prepend-icon="lock"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <action-button type="default" :text="$t('global.cancel')" @click="cancel" />
          <action-button type="default" :text="$t('auth.set_password')" @click="setpassword" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "CodePopup",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    uuid: {
      type: String
    },
    locale: {
      type: String
    },
    email: {
      type: String
    },
    email_validate_only: {
      type: Boolean
    }
  },

  data() {
    return {
      code: "",

      showPassword: false,
      new_password: "",
      new_password_retype: "",

      dictionary: {
        attributes: {
          "auth.code": "asd",
          "auth.new_password": this.$t("auth.new_password"),
          "auth.new_password_retype": this.$t("auth.new_password_retype")
        }
      }
    }
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  computed: {
    isCodeFormValid() {
      return !Object.keys(this.fields.$codeform).some((key) => this.fields.$codeform[key].invalid)
    },
    isPasswordFormValid() {
      return !Object.keys(this.fields.$passwordform).some((key) => this.fields.$passwordform[key].invalid && key != "auth.code")
    }
  },

  methods: {
    reset() {
      this.$refs.form.reset()
      this.refresh = true
    },

    cancel() {
      this.showPassword = false
      this.code = ""
      this.new_password = ""
      this.new_password_retype = ""
      this.$emit("callback_codepopup_cancel")
    },

    verify() {
      let vm = this

      this.$validator.validateAll("codeform").then((valid) => {
        if (valid && this.uuid) {
          axios
            .post(this.API_URL + "auth/validatecode", {
              uuid: this.uuid,
              code: this.code
            })
            .then((res) => {
              if (res.data.status == "code-found") {
                if (vm.email_validate_only) {
                  vm.$emit("callback_codepopup_register", null)
                } else {
                  vm.showPassword = true
                }
              } else {
                vm.$awn.alert(vm.$t("auth.code_enter_failed"))
              }
            })
            .catch((err) => console.log(err))
        }
      })
    },

    setpassword() {
      let vm = this

      this.$validator.validateAll("passwordform").then((valid) => {
        if (valid) {
          let password = vm.new_password
          vm.new_password = ""
          vm.new_password_retype = ""
          vm.showPassword = false
          vm.$emit("callback_codepopup_register", password)
        }
      })
    }
  }
}
</script>

<style scoped></style>
